import { replace } from 'connected-react-router';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';
import { Location } from './Location';

export function redirectWithBacklink(location: Location): ThunkAction<void, any> {
	return (dispatch) => {
		const currentLocation = window.location;
		const normalizedLocation = normalizeLocation(location);
		if (
			currentLocation.pathname === normalizedLocation.pathname &&
			currentLocation.search === normalizedLocation.search &&
			currentLocation.hash === normalizedLocation.hash
		) {
			return;
		}

		dispatch({
			type: ActionTypes.push,
			location: {
				pathname: currentLocation.pathname,
				search: currentLocation.search,
				hash: currentLocation.hash,
			},
		});
		dispatch(replace(normalizedLocation));
	};
}

export function redirectToBacklink(fallbackLocation: Location): ThunkAction<void, any> {
	return (dispatch, getState) => {
		const {
			backlink: { backlinks },
		} = getState();
		const location = backlinks[backlinks.length - 1];
		dispatch({ type: ActionTypes.pop });
		dispatch(replace(location || fallbackLocation));
	};
}

function normalizeLocation(location: Partial<Location>): Location {
	return {
		pathname: '',
		search: '',
		hash: '',
		...location,
	};
}
